import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useAssistantProperties } from '@wix/ai-scheduling-assistant-data-store';
import { Box, IconButton, Image, Text } from '@wix/design-system';
import { CenteredLoader } from '../../CenteredLoader';
import s from './avatar.scss';
export const BORING_AVATAR_CONTAINER_ID = 'AssistantAvatarContainer';
export const AssistantAvatar = props => {
  return 'withAssistantProperties' in props ? /*#__PURE__*/React.createElement(AssistantAvatarWithData, props) : /*#__PURE__*/React.createElement(AssistantAvatarUI, props);
};
const AssistantAvatarWithData = props => {
  const {
    assistantProperties
  } = useAssistantProperties();
  return /*#__PURE__*/React.createElement(AssistantAvatarUI, _extends({}, props, {
    assistantName: assistantProperties.name,
    variant: assistantProperties.avatarVariant,
    imageUrl: assistantProperties.imageUrl
  }));
};
const AssistantAvatarUI = _ref => {
  let {
    size = 36,
    assistantName = '',
    imageUrl,
    loading,
    indication,
    onIndicationClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      width: size,
      height: size
    }
  }, imageUrl ? /*#__PURE__*/React.createElement(Image, {
    borderRadius: "50%",
    style: {
      width: size,
      height: size
    },
    src: imageUrl
  }) : /*#__PURE__*/React.createElement(Box, {
    borderRadius: "50%",
    border: "1px solid",
    borderColor: "#ff7530",
    width: size,
    height: size,
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal",
    secondary: true,
    className: s.avatarText
  }, assistantName.charAt(0))), indication && /*#__PURE__*/React.createElement(Box, {
    className: s.avatarIndication
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    skin: "inverted",
    priority: "secondary",
    onClick: onIndicationClick
  }, indication)), loading && /*#__PURE__*/React.createElement(Box, {
    borderRadius: "50%",
    backgroundColor: "rgb(0,0,0, 0.50)",
    width: size,
    height: size,
    position: "absolute",
    top: size / 2,
    left: size / 2,
    style: {
      transform: `translate(-${size / 2}px, -${size / 2}px)`
    }
  }, /*#__PURE__*/React.createElement(CenteredLoader, {
    size: "tiny"
  })));
};
//# sourceMappingURL=AssistantAvatar.js.map